<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GOls0d/tc-custom/9780830828715.jpg?1696025335827" alt="This image is the cover for the book Positive Psychology in Christian Perspective, Christian Association for Psychological Studies Books"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Positive Psychology in Christian Perspective, Christian Association for Psychological Studies Books
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>"Some theories of [psychology] are based largely on the behavior of sick and anxious people or upon the antics of captive and desperate rats.</strong> Fewer theories have been derived from the study of healthy human beings, those who strive not so much to preserve life as to make it worth living. Thus we find . . . many studies of criminals, few of law-abiders; many of fear, few of courage; more on hostility than on affiliation; much on the blindness in man, little on his vision; much on his past, little on his outreaching into the future." —Gordon Allport, 1955</p> <p>Originally the field of psychology had a threefold mission: to cure mental illness, yes, but also to find ways to make life fulfilling for all and to maximize talent. Over the last century, a focus on mental illness has often been prioritized over studies of health, to the point that many people assume "psychologist" is just another way of saying "psychotherapist." This book is about one attempt to restore the discipline's larger mission.</p> <p>Positive psychology attends to what philosophers call "the good life." It is about fostering strength and living well—about how to do a good job at being human. Some of that will involve cheerful emotions, and some of it will not. There are vital roles to be played by archetypal challenges such as those involving self-control, guilt, and grit, and even the terror of death enters into positive psychology's vision of human flourishing.</p> <p>Charles Hackney connects this still-new movement to foundational concepts in philosophy and Christian theology. He then explores topics such as subjective states, cognitive processes, and the roles of personality, relationships, and environment, also considering relevant practices in spheres from the workplace to the church and even the martial arts dojo. Hackney takes seriously the range of critiques positive psychology has faced as he frames a constructive future for Christian contributions to the field.</p> <p>Christian Association for Psychological Studies (CAPS) Books explore how Christianity relates to mental health and behavioral sciences including psychology, counseling, social work, and marriage and family therapy in order to equip Christian clinicians to support the well-being of their clients.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charles Hackney
      </h2>
      
      <p class="authorDescription body article"><p>Charles Hackney (PhD, SUNY Albany) is associate professor of psychology at Southern Wesleyan University in South Carolina.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5b66ddd6